import { useMemo, useState } from "react";
import { GeoJSON, Marker, Polyline, Tooltip } from "react-leaflet";
import { divIcon, icon } from "leaflet";

import { Box, Card, Stack, Typography } from "@mui/material";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { renderToStaticMarkup } from "react-dom/server";

import Icon from "Components/Icon";
import { selectCamera } from "Redux/cameraSlice";
import useEvenets from "Hooks/useEvenets";
import { EVENTS_TYPES } from "Constants/traffic";

const ICON_SIZE = 22;

export default function Events() {
  const dispatch = useAppDispatch();
  const { visible, selectedCamera } = useAppSelector((state) => state.event);

  const { data } = useEvenets();

  const eventMarkers = useMemo(() => {
    return data?.map((item: any) => {
      if (!item.Incidents) return;
      const event = JSON.parse(`{${item.Incidents}}`);
      const eventData = EVENTS_TYPES.filter((c) => c.type === event.Type)[0];

      const eventIconMarkup = renderToStaticMarkup(
        <Box
          style={{
            width: "35px",
            height: "35px",
            backgroundColor: "#fffd",
            borderRadius: "50%",
            border: "2px solid",
            borderColor: "#62b362cc",
            display: "grid",
            placeItems: "center",
            color: "#666",
          }}
        >
          <img src={eventData?.imgSrc} alt="test" style={{ width: "28px" }} />
        </Box>
      );

      const eventIcon = divIcon({
        html: eventIconMarkup,
        iconSize: [ICON_SIZE, ICON_SIZE],
        iconAnchor: [18, 30],
      });

      const events = {
        click: () => {
          if (selectedCamera[0]?.DeviceCode === event.DeviceCode) {
            dispatch(selectCamera([]));
          } else {
            dispatch(selectCamera([event]));
          }
          //   dispatch(
          //     createTrafficAnalysisStarUrl([
          //       `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=54c0cd88-12de-4c51-8685-c44b92b737d6&paramvalues={"6fdfaf88-4f4a-cc25-ecaf-2da853c48f65":[{"Value":{"Id":"${event?.DeviceCode}","Value":${event?.DeviceCode},"DisplayValue":${event?.DeviceCode}},"FromColumn":false,"SelectedField":null}]}`,
          //       `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=e2ffa658-2244-4b16-99d4-2f5e11e39bfb&paramvalues={"6fdfaf88-4f4a-cc25-ecaf-2da853c48f65":[{"Value":{"Id":${event?.DeviceCode},"Value":${event?.DeviceCode},"DisplayValue":${event?.DeviceCode}},"FromColumn":false,"SelectedField":null}]}`,
          //     ])
          //   );
        },
      };

      // const tooltipContent = (
      //   <Tooltip direction="top" offset={[0, -20]}>
      //     <Card sx={{ py: 2, px: 3, direction: "ltr" }}>
      //       <Stack alignItems="center">
      //         <Stack direction="row" sx={{ justifyContent: "space-between", width: "100%" }}>
      //           <Typography> نوع موقعیت:</Typography>
      //           <Typography>{event.Location_Type}</Typography>
      //         </Stack>
      //         <Stack direction="row" sx={{ justifyContent: "space-between", width: "100%" }}>
      //           <Typography>
      //             {" "}
      //             نوع حادثه :<Typography> {event.Type}</Typography>
      //           </Typography>
      //         </Stack>
      //         <Stack direction="row" sx={{ justifyContent: "space-between", width: "100%" }}>
      //           <Typography>
      //             {" "}
      //             منطقه :<Typography> {event.Zone_Name}</Typography>
      //           </Typography>
      //         </Stack>
      //         <Stack direction="row" sx={{ justifyContent: "space-between", width: "100%" }}>
      //           <Typography>
      //             موقعیت مکانی : <Typography>{event?.Location_Name}</Typography>
      //           </Typography>
      //         </Stack>
      //       </Stack>
      //     </Card>
      //   </Tooltip>
      // );

      const tooltipContent = (
        <Tooltip direction="top" offset={[0, -20]}>
          <Card sx={{ py: 2, px: 3 }}>
            <Stack alignItems="flex-end">
              <Typography> نوع موقعیت: {event.Location_Type}</Typography>
              <Typography> نوع حادثه : {event.Type}</Typography>
              <Typography> منطقه : {event.Zone_Name}</Typography>
              <Typography>موقعیت مکانی : {event.Location_Name}</Typography>
            </Stack>
          </Card>
        </Tooltip>
      );

      return (
        <>
          <Marker key={`event-${event.ID}`} position={[event.long, event.lat]} icon={eventIcon} eventHandlers={events}>
            {tooltipContent}
          </Marker>
        </>
      );
    });
  }, [data, visible]);

  if (!visible) return <></>;

  return <>{eventMarkers}</>;
}
